import React from 'react'

const Footer = () => {
  return (
      <section className="footer">
        <span>Volcan productora</span>
        <p><a href="#somos"> Volver al inicio</a></p>
        <p>Email: volcanproductora@gmail.com</p>
  </section>
  )
}

export default Footer
